import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { ImageComponent } from "@portal/BaseComponents/Image/AntImage";
import image from "@portal/assets/login-bg 1.png";
import { useState } from "react";

import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import {
  Paragraph,
  TypographyText,
} from "@portal/BaseComponents/Typography/AntTypography";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { LOGIN_ERROR_STATUS } from "@portal/types/common";
import { useAtomValue } from "jotai";
import { AlertStatus, AlterInfo, OTPErrorInfo } from "./PinLogin/AlterInfo";
import { PinLogin } from "./PinLogin/PinLogin";
import { LoginFormWrapper, StyledImage } from "./style";

const t = {
  heading: "Customer Portal",
};
function LoginForm() {
  const [loginStatus, setLoginStatus] = useState<LOGIN_ERROR_STATUS>();
  const [status, setStatus] = useState<AlertStatus>();
  const { visualConfig } = useAtomValue(userConfigAtom);
  function handleUpdateStatus(status?: AlertStatus) {
    setStatus(status);
  }
  function handleLoginErrorStatus(status?: LOGIN_ERROR_STATUS) {
    setLoginStatus(status);
  }

  const Logo = (
    <StyledImage src={visualConfig.config?.logo_uri} preview={false} />
  );
  const Heading = (
    <TypographyText strong fs="20">
      {visualConfig.config?.portal_name
        ? visualConfig.config.portal_name
        : t.heading}
    </TypographyText>
  );
  const CompanyName = (
    <TypographyText fs="16">{visualConfig.config?.company_name}</TypographyText>
  );
  const Desc = (
    <Paragraph
      fs="16"
      style={{ color: "var(--gray-8)", textAlign: "left", marginBottom: "0" }}
    >
      {visualConfig.config?.description}
    </Paragraph>
  );

  const Info = (
    <Flex vertical space="4" align="start">
      {CompanyName}
      {Heading}
      {Desc}
    </Flex>
  );

  const Header = (
    <Flex vertical space="12" align="start">
      {Logo}
      {Info}
    </Flex>
  );

  const Banner = (
    <Flex justify="flex-end" style={{ width: "100%" }}>
      <ImageComponent src={image} preview={false} />
    </Flex>
  );
  const PinArea = (
    <Flex vertical space="20" style={{ width: "100%" }}>
      <OTPErrorInfo
        status={loginStatus}
        key={status}
        onSuccessCallBack={() => {
          setLoginStatus(undefined);
        }}
      />
      <HideWrapper hide={Boolean(loginStatus)}>
        <AlterInfo status={status} />
      </HideWrapper>
      <PinLogin
        updateStatus={handleUpdateStatus}
        status={status}
        loginErrorStatus={loginStatus}
        handleLoginErrorStatus={handleLoginErrorStatus}
      />
    </Flex>
  );
  const Content = (
    <Flex
      vertical
      style={{ padding: "var(--space-40)", width: "100%" }}
      space="28"
    >
      {Header}
      {PinArea}
    </Flex>
  );

  return (
    <LoginFormWrapper vertical justify="space-between" align="start" space="48">
      {Content}
      {Banner}
    </LoginFormWrapper>
  );
}

export { LoginForm };
